import React, { useState, useMemo, useEffect } from 'react'
import { determineCommaSeprater, dropDownSelectionStyles, FormatInvoiceDecimalNumber, formatNumberCustomoriginal, formatNumberCustomoriginalapiv2, getValueFromResource, normalizeDateFormat, validateCultureNumber } from '../../common/timeLiveFunction'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { KTSVG } from '../../_metronic/helpers';
import Select from 'react-select';
import { DateRangePicker } from 'rsuite';
import DatePickerRanges from '../../common/DatePickerRanges';
import { countWorkingDays } from '../utils/dataAdapter';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';
import moment from 'moment';
import { DeleteAccountEmployeeScheduler } from './SchedulerSlice';
import { ShowToast } from '../../common/Toastr';
import { countAllDays, isWeekendDay } from '../utils/dateUtils';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';

const AssignTask = ({ onClose, onTaskSaved }: any) => {
    const { assignmentModalData, tabs,IsAdd, IsDelete, IsEdit } = useAppSelector((state) => state.scheduler);
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [isSaving, setIsSaving] = useState(false);
    const initialDates = useMemo(() => {
        const clicked = assignmentModalData?.clickedDate || new Date();
        const taskHoursPerDay = assignmentModalData?.HoursPerDay || 0;
        return {
            start: new Date(clicked),
            end: new Date(clicked),
            hoursPerDay: taskHoursPerDay,
        };
    }, [assignmentModalData?.clickedDate]);
    const [SelectedStartDate, setSelectedStartDate] = useState(initialDates.start);
    const [isWeekendAssignment, setIsWeekendAssignment] = useState(false);
    const [SelectedEndDate, setSelectedEndDate] = useState(initialDates.end);
    const [WorkingDays, setWorkingDays] = useState(0);
    const [hoursPerDay, setHoursPerDay] = useState<any | ''>(initialDates?.hoursPerDay ?? '');
    const [maxHours, setMaxHours] = useState(initialDates?.hoursPerDay);
    const [taskOptions, setTaskOptions] = useState<any[]>([]);
    const [selectedTask, setSelectedTask] = useState<any>();
    const [editData, setEditData] = useState<any>({});
    const [totalHours, setTotalHours] = useState(initialDates?.hoursPerDay);
    const [isEditTask, setIsEditTask] = useState(false);
    const [isDeleteTask, setIsDeleteTask] = useState(false);
    const AccountId = localStorage.getItem('accountId');
    const updateTask = assignmentModalData?.types === 'task' || assignmentModalData?.types === 'taskTeam';
    const IsActiveTab = tabs === 'team'

    const getTaskList = async () => {
        const response = await fetchTimeliveAPI(`api/Task/GetAssignedProjectEmployeeTaskDropdown/${assignmentModalData?.ProjectId}/${assignmentModalData?.AccountEmployeeId}`, 'GET', "", true)
        const result = await response.json()
        let Options = result?.Data?.map((items: any) => ({
            label: items?.TaskName,
            value: items?.AccountProjectTaskId
        }))

        Options = [
            { label: "None", value: 0 },
            ...Options
        ];

        setTaskOptions(Options);
        if (!updateTask) {
            setSelectedTask(0);
        }
    }

    const getAssignmentData = async () => {
        const { parentId, AccountEmployeeId, AccountEmployeeSchedulerId, AccountProjectTaskId, ProjectId } = assignmentModalData;
        const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountEmployeeSchedulerById/${ProjectId}/${AccountProjectTaskId}/${AccountEmployeeSchedulerId}`, 'GET', '', true);
        const result = await response.json();
        if (result.StatusCode == 200) {
            const data = result?.Data[0];
            const permissionForEdit = data?.ApplyAllProjectsForEdit ? data?.ApplyAllProjectsForEdit : data?.ApplyMyProjectsForEdit ? data?.ApplyMyProjectsForEdit : data?.ApplyMyForEdit;
            const permissionForDelete = data?.ApplyAllProjectsForDelete ? data?.ApplyAllProjectsForDelete : data?.ApplyMyProjectsForDelete;
            setIsEditTask(permissionForEdit);
            setIsDeleteTask(permissionForDelete);
            const startMoment = moment(data?.StartDate);
            const endMoment = moment(data?.EndDate);
            const normalizeAllocationHoursPerDay = FormatInvoiceDecimalNumber(cultureInfoName.toString(), data?.AllocationHoursPerDay, 2);
            setEditData(data);
            setSelectedTask(data?.AccountProjectTaskId);
            setSelectedStartDate(startMoment.isValid() ? startMoment.toDate() : new Date());
            setSelectedEndDate(endMoment.isValid() ? endMoment.toDate() : new Date());
            setHoursPerDay(normalizeAllocationHoursPerDay);
            // setHoursPerDay(data?.AllocationHoursPerDay);
            setTotalHours(data?.AllocationHours);
        }
    }

    useEffect(() => {
        if (assignmentModalData?.parentId) {
            getTaskList();
        }
    }, [assignmentModalData])

    useEffect(() => {
        if (updateTask && taskOptions.length > 0 && editData?.AccountProjectTaskId) {
            setSelectedTask(editData.AccountProjectTaskId);
        }
    }, [taskOptions, editData, updateTask]);

    useEffect(() => {
        if (assignmentModalData?.clickedDate) {
            const clickedDate = new Date(assignmentModalData.clickedDate);
            setIsWeekendAssignment(isWeekendDay(clickedDate));
        }
    }, [assignmentModalData?.clickedDate]);

    useEffect(() => {
        if (SelectedStartDate && SelectedEndDate) {
            let days;

            if (isWeekendAssignment) {
                days = countAllDays(SelectedStartDate, SelectedEndDate);
            } else {
                days = countWorkingDays(SelectedStartDate, SelectedEndDate);
            }

            setWorkingDays(days);

            if (hoursPerDay !== '' && days > 0) {
                setTotalHours(Number(hoursPerDay) * days);
            } else if (days === 0) {
                setTotalHours(0);
            }
        }
    }, [SelectedStartDate, SelectedEndDate, hoursPerDay, isWeekendAssignment]);

    useEffect(() => {
        if (hoursPerDay !== '' && WorkingDays > 0) {
            const normalizedValue = hoursPerDay.toString().replace(',', '.');
            const numericValue = parseFloat(normalizedValue);
            // setTotalHours(Number(hoursPerDay) * WorkingDays);
            if (!isNaN(numericValue)) {
                setTotalHours(numericValue * WorkingDays);
            }
        } else {
            setTotalHours(0);
        }
    }, [WorkingDays, hoursPerDay]);

    useEffect(() => {
        if (updateTask) {
            getAssignmentData();
        }
    }, [updateTask])

    const handleDateRangeChange = (value: any) => {
        if (value?.length === 2) {
            const start = value[0];
            const end = value[1];
            setSelectedStartDate(value[0]);
            setSelectedEndDate(value[1]);
            const days = countWorkingDays(start, end);
            setWorkingDays(days);
        }
    };

    const handleSaveTask = async () => {
        if (isSaving) return;
        setIsSaving(true);
        if (!IsEdit || (IsEdit && updateTask && !isEditTask)) {
            setIsSaving(false);
            ShowToast('Error', "You do not have permission to edit task.", "error", "toast-top-right");
            onClose();
            return;
        }
        if (updateTask) {
            const { AccountEmployeeSchedulerId, AllocationHours } = editData || {}
            try {
                const payload = {
                    AccountId: AccountId,
                    AccountProjectId: assignmentModalData?.ProjectId,
                    AccountEmployeeId: assignmentModalData?.AccountEmployeeId,
                    AccountProjectTaskId: selectedTask,
                    AccountEmployeeSchedulerId: AccountEmployeeSchedulerId,
                    StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
                    EndDate: moment(SelectedEndDate).format('YYYY-MM-DD'),
                    AllocationHours: totalHours,
                    AllocationHoursPerDay: typeof hoursPerDay === 'string' ? parseFloat(hoursPerDay.replace(',', '.')) : hoursPerDay,
                    // AllocationHoursPerDay: hoursPerDay,
                }

                const response = await fetchTimeliveAPI(`api/Scheduler/UpdateAccountEmployeeScheduler/${assignmentModalData?.AccountEmployeeSchedulerId ?? AccountEmployeeSchedulerId}`, 'PUT', payload, true);
                const result = await response.json();
                if (result?.StatusCode === '200') {
                    if (onTaskSaved && assignmentModalData?.parentId) {
                        ShowToast('Success', result?.ResponseMessage, "success", "toast-top-right");
                        await onTaskSaved(assignmentModalData.parentId);
                    }
                    onClose();
                } else {
                    ShowToast('Error', result?.ResponseMessage, "error", "toast-top-right");
                }
            } catch (error) {
                console.error("Error saving task:", error);
                ShowToast('Error', error, "error", "toast-top-right");
            } finally {
                setIsSaving(false);
            }
        } else {
            try {
                if(!IsAdd){
                    ShowToast('Error', "You do not have permission to add task.", "error", "toast-top-right");
                    onClose();
                    return;
                }
                const payload = {
                    AccountId,
                    AccountProjectId: assignmentModalData?.ProjectId,
                    AccountEmployeeId: assignmentModalData?.AccountEmployeeId,
                    AccountProjectTaskId: selectedTask,
                    StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
                    EndDate: moment(SelectedEndDate).format('YYYY-MM-DD'),
                    AllocationHours: totalHours ?? 0,
                    AccountWorkTypeId: null,
                    AllocationHoursPerDay: typeof hoursPerDay === 'string' ? parseFloat(hoursPerDay.replace(',', '.')) : hoursPerDay,
                    // AllocationHoursPerDay: hoursPerDay,
                }

                const response = await fetchTimeliveAPI(`api/Scheduler`, 'POST', payload, true);
                const result = await response.json();
                if (result?.StatusCode === '201') {
                    ShowToast('Success', result?.ResponseMessage, "success", "toast-top-right");
                    if (onTaskSaved && assignmentModalData?.parentId) {
                        await onTaskSaved(assignmentModalData.parentId);
                    }
                    onClose();
                } else {
                    ShowToast('Error', result?.ResponseMessage, "error", "toast-top-right");
                }
            } catch (error) {
                console.error("Error saving task:", error);
                ShowToast('Error', error, "error", "toast-top-right");
            } finally {
                setIsSaving(false);
            }
        }
    }

    const handleDelete = async () => {
        try {
            const result = await ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container');
            if (!result) return;

            const payload = {
                accountEmployeeSchedulerId: assignmentModalData?.AccountEmployeeSchedulerId,
                accountProjectTaskId: assignmentModalData?.AccountProjectTaskId,
            };

            const response = await dispatch(DeleteAccountEmployeeScheduler(payload));

            if (response) {
                if (onTaskSaved && assignmentModalData?.parentId) {
                    ShowToast('Success', response, "success", "toast-top-right");
                    await onTaskSaved(assignmentModalData.parentId);
                }
                onClose();
            }
        } catch (error) {
            console.log(error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    };

    return (
        <div className="card-body">
            <div className="modal drawer-overlay" style={{ display: 'block' }}>
                <div className="modal-dialog">
                    <div className="modal-content" style={{ maxHeight: '70vh' }}>

                        <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                            <div className="d-flex align-items-center gap-2">
                                <h5 className="modal-title mainHeading">
                                    {getValueFromResource(`${updateTask ? getValueFromResource('Edit Scheduled Hours', dispatch, t) : getValueFromResource('Schedule Hours', dispatch, t)}`, dispatch, t)}
                                </h5>
                                {(updateTask &&  IsDelete)&& <i className="bi bi-trash fs-5 delete-menu-icon-color allign cursor-pointer"
                                    data-tooltip-id="scheduler-event-tooltip"
                                    data-tooltip-content={getValueFromResource('Delete', dispatch, t)}
                                    onClick={handleDelete}
                                ></i>}
                            </div>
                            <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                            </div>
                        </div>

                        <div className="modal-body" style={{ overflowY: 'auto' }}>

                            <div className='d-flex gap-2'>
                                <span className='fw-bold headerTitle'>{IsActiveTab ? getValueFromResource('Employee Name', dispatch, t) : getValueFromResource('Project Name', dispatch, t)}</span>
                                {/* <span className="bullet bg-gray-400 w-5px h-2px mt-3"></span> */}
                                <span className="text-muted me-2 fs-6">{IsActiveTab ? `: ${assignmentModalData?.employeeName}` : `: ${assignmentModalData?.parentName}`}</span>
                            </div>

                            <div className='d-flex gap-2'>
                                <span className='fw-bold headerTitle'>{IsActiveTab ? getValueFromResource('Project And Client', dispatch, t) : getValueFromResource('Employee Name', dispatch, t)}</span>
                                {/* <span className="bullet bg-gray-400 w-5px h-2px mt-3"></span> */}
                                <span className="text-muted me-2 fs-6">{IsActiveTab ? `: ${assignmentModalData?.name} - ${assignmentModalData?.subtitle}` : `: ${assignmentModalData?.name}`}</span>
                            </div>

                            <div className="separator my-2"></div>
                            <div>
                                <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Task', dispatch, t)}</label>
                                <Select
                                    value={taskOptions?.find((option) => option.value === selectedTask)}
                                    onChange={(option: any) => setSelectedTask(option.value)}
                                    options={taskOptions}
                                    styles={{
                                        ...dropDownSelectionStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    maxMenuHeight={maxMenuHeight}
                                    menuPlacement="auto"
                                />
                            </div>
                            <div className='my-2'>
                                <div className="d-flex justify-content-between">
                                    <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Period', dispatch, t)}</label>
                                    <label className="form-label fs-7 fw-normal mb-2">{WorkingDays} {getValueFromResource('Working Days', dispatch, t)}</label>
                                </div>

                                <DateRangePicker
                                    value={[SelectedStartDate, SelectedEndDate]}
                                    onChange={handleDateRangeChange}
                                    ranges={DatePickerRanges()}
                                    format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                    placement="bottomEnd"
                                    cleanable={false}
                                />
                            </div>
                            <div className="my-2">
                                <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Hours per day', dispatch, t)}</label>

                                <div className="position-relative">
                                    {/* <input
                                        type="text"
                                        className="form-control fs-7 fw-normal pe-5"
                                        value={hoursPerDay}
                                        min={0}
                                        max={maxHours}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                          
                                            setHoursPerDay(value === '' ? '' : Number(value));
                                            if (value !== '' && WorkingDays > 0) {
                                                setTotalHours(Number(value) * WorkingDays);
                                            }
                                        }}
                                    /> */}
                                    <input
                                        type="text"
                                        className="form-control fs-7 fw-normal pe-5"
                                        value={hoursPerDay}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
                                            if (isCommaSeparator && value.includes('.')) {
                                                return;
                                            }
                                            if (!isCommaSeparator && value.includes(',')) {
                                                return;
                                            }
                                            if (value === "" || validateCultureNumber(value, cultureInfoName.toString(), 2)) {
                                                setHoursPerDay(value);
                                                if (value !== '' && WorkingDays > 0) {
                                                    const normalizedValue = value.toString().replace(',', '.');
                                                    const numericValue = parseFloat(normalizedValue);

                                                    if (!isNaN(numericValue)) {
                                                        setTotalHours(numericValue * WorkingDays);
                                                    }
                                                } else {
                                                    setTotalHours(0);
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const value = e.target.value;

                                            if (value === '') return;
                                            const normalizedValue = value.toString().replace(',', '.');
                                            const numericValue = parseFloat(normalizedValue);

                                            if (isNaN(numericValue)) return;
                                            const fixedValue = Number(numericValue.toFixed(2));
                                            const formattedValue = FormatInvoiceDecimalNumber(
                                                cultureInfoName.toString(),
                                                fixedValue,
                                                2
                                            );

                                            setHoursPerDay(formattedValue);
                                            if (WorkingDays > 0) {
                                                setTotalHours(fixedValue * WorkingDays);
                                            }
                                        }}
                                    />
                                    <span
                                        className="position-absolute text-muted"
                                        style={{
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            pointerEvents: "none",
                                            fontSize: "12px"
                                        }}
                                    >
                                        of {FormatInvoiceDecimalNumber(cultureInfoName.toString(), maxHours, 2)}
                                    </span>
                                </div>
                            </div>
                            <div className="">
                                <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Total hours', dispatch, t)} : {FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours, 2)}</label>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary btn-sm" onClick={onClose} disabled={isSaving}>
                                {getValueFromResource('Cancel', dispatch, t)}
                            </button>
                            <button className="btn btn-primary btn-sm" onClick={handleSaveTask} disabled={isSaving}>
                                {getValueFromResource('Save', dispatch, t)}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AssignTask;
